'use client'

import Image from 'next/image'

type FlagImageProps = {
  code: string
  alt: string
  width?: number
  height?: number
}

const FlagImage = ({ code, alt, width = 25, height = 15 }: FlagImageProps) => {
  const src = `https://flagcdn.com/w40/${code.toLowerCase()}.png`

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      unoptimized // ✅ Vì ảnh không qua loader nội bộ
      priority={false}
    />
  )
}

export default FlagImage
